import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import ProcessMaps from '../components/ProcessMaps/ProcessMaps';

const ProcessMapsBridge = react2angular(ProcessMaps, ['isMobile', 'backFromState']);

export default ProcessMapsBridge;
